import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { getDailyBonusTopic } from '../../../data/league-config';
import { DailyBonus } from '../../../interfaces/score.interface';
import { GlobalService } from 'src/app/_services/global.service';

@Component({
  selector: 'app-daily-bonus',
  template: `
    <div class="daily-bonus">
      <span class="bonus-icon">&#9733;</span>
      <span class="bonus-text">{{getLabel()}}</span>
      <span class="bonus-mult">{{bonus.multiplier | arabicNumber:currLang}}x</span>
    </div>
  `,
  styles: [`
    .daily-bonus {
      display: flex;
      align-items: center;
      gap: calc(10px * var(--game-scale, 1));
      padding: calc(8px * var(--game-scale, 1)) calc(18px * var(--game-scale, 1));
      border-radius: 24px;
      background: linear-gradient(135deg, rgba(255, 215, 0, 0.15), rgba(255, 160, 0, 0.15));
      border: 1px solid rgba(255, 215, 0, 0.3);
    }
    .bonus-icon { font-size: calc(18px * var(--game-scale, 1)); color: #FFD700; }
    .bonus-text { color: #FFD700; font-size: calc(16px * var(--game-scale, 1)); font-weight: 600; }
    .bonus-mult { color: #FFA000; font-size: calc(15px * var(--game-scale, 1)); font-weight: 700; opacity: 0.8; }
  `]
})
export class DailyBonusComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  bonus: DailyBonus;
  currLang: any = 'en';

  constructor(private globalService: GlobalService) {
    this.bonus = getDailyBonusTopic();
  }

  ngOnInit(): void {
    this.globalService.getLang()
      .pipe(takeUntil(this.destroy$))
      .subscribe(lang => this.currLang = lang);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getLabel(): string {
    return this.currLang === 'ar' ? this.bonus.label.ar : this.bonus.label.en;
  }
}
